module.exports = __webpack_public_path__ + "img/application5.10f1ae17.png";